module.exports = __webpack_public_path__ + "static/media/tern.54662f60.svg";